module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/banner_ritou-b173dfa26cafe589883bb901fc795666.png";